import { Box } from "@mui/material";
import { style } from "./inputChip.style";

export const InputChip = ({ icon, customStyles }) => (
  <Box sx={[style.chip, customStyles]}>
    {icon}
  </Box>
);
